import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { ContactSeller } from '../ContactSeller/ContactSeller';
import PaymentDrawerFooter from '../PackagesTabs/TabContent/PaymentDrawerFooter';
import { CustomOrder } from '../../types/seller';

interface StickyContactCTAProps {
  customOrder: CustomOrder;
  hidden: boolean;
  isInLynxesCtaReworkExperiment?: boolean;
}

const StickyContactCTA = ({ customOrder, hidden, isInLynxesCtaReworkExperiment = false }: StickyContactCTAProps) => (
  <Stack
    direction="rowReverse"
    gap="4"
    position="fixed"
    bottom={0}
    left={0}
    right={0}
    width="100%"
    paddingX="6"
    paddingY="5"
    zIndex="overlay"
    backgroundColor="white"
    borderTopWidth="sm"
    borderColor="grey_400"
    transition="transform 0.3s ease, opacity 0.3s ease"
    transform={hidden ? 'translateY(100%)' : 'translateY(0)'}
    pointerEvents={hidden ? 'none' : undefined}
    visibility={hidden ? 'hidden' : 'visible'}
  >
    <ContactSeller customOrder={customOrder} isStickyContactCTA hidden={hidden} />
    <PaymentDrawerFooter isStickyContactCTA isInLynxesCtaReworkExperiment={isInLynxesCtaReworkExperiment} />
  </Stack>
);

export default StickyContactCTA;
